import {FilePreview} from "./FilePreview";
import {Component} from "inferno";
import {Deferred} from "@sap/cpaas-commlib-lib";
import {Configuration} from "../../services/configuration";

export type FileConstraints = { acceptAttachmentMimeTypes: string, attachmentSizeLimitMB: number, attachmentsTotalSizeLimitMB: number };

export interface IFile extends File {
	valid: boolean;
	validMime: boolean;
	selected: boolean;
	url: any;
}

export type Props = { onAttachFiles: (files: File[]) => void, onAttachHtml: (html: string) => void, click?: boolean, showPreview?: boolean, target?: any, active: boolean };
export type State = { preview: any, mime: string };

export class MediaDrop extends Component<Props, State> {

	control: any;
	fileInput: any;
	constraints: FileConstraints = {
		acceptAttachmentMimeTypes: "",
		attachmentSizeLimitMB: 25,
		attachmentsTotalSizeLimitMB: 25,
	};

	state: State = {
		mime: "",
		preview: null,
	};

	async componentDidMount() {
		this.control = this.props.target ? this.props.target : document.querySelector("#chat-root");
		this.control.addEventListener("drop", this.onDrop, false);
		this.control.addEventListener('dragover', this.onDragover, false);
		if (this.props.click === true) {
			this.control.addEventListener("click", this.open);
		}
		// get constraints from DB
		/*try {
			this.constraints = await (await fetch(Configuration.endpoint + "/attachment/settings", {credentials: "include"})).json();
			this.setState({"mime": this.constraints.acceptAttachmentMimeTypes});
		} catch (e) {
			// use defaults
		}*/
	}

	componentWillUnmount() {
		this.control.removeEventListener("drop", this.onDrop, false);
		this.control.removeEventListener('dragover', this.onDragover, false);
		this.control.removeEventListener("click", this.open);
	}

	private valid(mime: string) {
		return !(this.state.mime !== "" && this.state.mime.indexOf(mime) === -1);
	}

	open = () => {
		this.fileInput.click();
	};

	onDrop = async (e: any) => {
		e.stopPropagation();
		e.preventDefault();
		const files: IFile[] = [];
		const entries = e.dataTransfer.items || [];
		for (const entry of entries) {
			if (entry.kind === "file") {
				files.push(entry.getAsFile());
			} else if (entry.kind === "string" && entry.type === "text/html") {
				if (this.props.onAttachHtml) {
					const html = await new Promise<string>((resolve) => entry.getAsString(resolve));
					this.props.onAttachHtml(html);
				}
			}
		}
		if (files.length > 0) {
			this.attachFiles(files);
		}
	};

	onDragover = (e: any) => {
		e.stopPropagation();
		e.preventDefault();
	};

	onSelect = (e: any) => {
		this.attachFiles(Array.from(e.target.files));
	};

	attachFiles = async (files: IFile[]) => {
		if (!this.props.active || files.length === 0) {
			return;
		}
		for (const file of files) {
			file.selected = true;
			file.valid = true;
			file.validMime = this.valid(file.type);
			if (file.size > this.constraints.attachmentSizeLimitMB * 1000000 || !file.validMime) {
				file.valid = false;
				file.selected = false;
			} else if (this.props.showPreview !== false) {
				try {
					// Load preview to url parameter
					const readResult: any = await new Promise((resolve) => {
						const reader = new FileReader();
						reader.onload = resolve;
						reader.readAsDataURL(file);
					});
					file.url = readResult.target.result;
				} catch (e) {
					// ignore
				}
			}
		}
		if (this.props.showPreview === false) {
			this.props.onAttachFiles(files.filter((item: any) => item.valid === true));
		} else {
			// build preview UI
			const deferred = new Deferred();
			const preview = <FilePreview deferred={deferred} files={files} sizeLimit={this.constraints.attachmentSizeLimitMB + "MB"}/>;
			this.setState({preview});
			if ((await deferred.promise) === true) {
				// send only selected and valid
				this.props.onAttachFiles(files.filter((item: any) => item.selected === true && item.valid === true));
			}
			this.setState({preview: null});
		}
	};

	render() {
		return [
			<input type="file" multiple={true} style={{display: "none"}} ref={(input: any) => this.fileInput = input} accept={this.state.mime} onChange={this.onSelect}/>,
			this.props.children,
			this.state.preview,
		];
	}
}
